import React from 'react';
export default class AppBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('Page failed to render', error, info); }
  render() {
    if (this.state.error) return <main className="erp-empty" role="alert"><h1>This page could not open</h1><p>Please reload to try again. Your saved records are safe.</p><button className="erp-button" onClick={() => window.location.reload()}>Reload page</button><a href="/">Return to workspace</a></main>;
    return this.props.children;
  }
}
